var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { apiSlice } from "./api";
import { mvcApiSlice } from "./mvc";
import themeSliceReducer from "./themeSlice";
import layoutSliceReducer from "./layoutSlice";
import authSliceReducer from "./authSlice";
import filterSliceReducer from "./filterSlice";
import fieldSliceReducer from "./fieldSlice";
import sortSliceReducer from "./sortSlice";
import colorSliceReducer from "./colorSlice";
//import themeadminReducer from "./themeadminSlice";
import themeVariantListenerMiddleware from "./listeners/themeVariant";
import { persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER, } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { Slot } from "@/utils/types/layout";
import moduleBuilderReducer from "./moduleBuilderSlice";
import administrationReducer from "./administrationSlice";
import systemConfigReducer from "./systemConfigSlice";
var blacklist = [
    "api",
    "mvcApi",
    "layout.slots.".concat(Slot.MODAL),
    "layout.slots.".concat(Slot.DRAWER_EAST),
    ,
    "layout.slots.".concat(Slot.DRAWER_WEST),
    ,
    "layout.slots.".concat(Slot.DRAWER_NORTH),
    ,
    "layout.slots.".concat(Slot.DRAWER_SOUTH),
];
if (process.env.NODE_ENV === "development") {
    blacklist.push("theme");
}
var persistConfig = {
    key: "root",
    storage: storage,
    blacklist: blacklist,
    migrate: function (state) {
        var newState = __assign({}, state);
        [
            Slot.MODAL,
            Slot.DRAWER_EAST,
            Slot.DRAWER_EAST,
            Slot.DRAWER_SOUTH,
            Slot.DRAWER_WEST,
        ].forEach(function (slot) {
            var _a;
            if ((_a = newState === null || newState === void 0 ? void 0 : newState.layout) === null || _a === void 0 ? void 0 : _a.slots) {
                newState.layout.slots[slot].widgets = [];
            }
        });
        return Promise.resolve(newState);
    },
};
var rootReducers = combineReducers((_a = {
        theme: themeSliceReducer,
        layout: layoutSliceReducer,
        auth: authSliceReducer,
        filter: filterSliceReducer,
        field: fieldSliceReducer,
        colorsIcon: colorSliceReducer,
        //themeconfigs: themeadminReducer,
        moduleBuilder: moduleBuilderReducer,
        adminMenu: administrationReducer,
        sort: sortSliceReducer,
        systemConfig: systemConfigReducer
    },
    _a[apiSlice.reducerPath] = apiSlice.reducer,
    _a[mvcApiSlice.reducerPath] = mvcApiSlice.reducer,
    _a));
var persistedReducer = persistReducer(persistConfig, rootReducers);
var store = configureStore({
    reducer: persistedReducer,
    middleware: function (getDefaultMiddleware) {
        return getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }).concat(apiSlice.middleware, mvcApiSlice.middleware, themeVariantListenerMiddleware.middleware);
    },
});
export default store;
